<template>
    <el-table-draggable :animate="300" @drop="$emit('orderChanged', $event)">
        <el-table
            style="width: 100%"
            max-height="700"
            :data="preOrderUnits"
            :row-class-name="$style.row"
            empty-text="No results found."
            @row-click="$emit('rowClicked', $event)"
        >
            <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :width="column.width"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
                :formatter="column.formatter"
                :show-overflow-tooltip="true"
            />
        </el-table>
    </el-table-draggable>
</template>

<script>
import moment from "moment-timezone";
import ElTableDraggable from "element-ui-el-table-draggable";

export default {
    name: "PreOrderUnitTable",
    components: {
        ElTableDraggable,
    },
    props: {
        preOrderUnits: {
            type: Array,
            required: true,
        },
    },
    computed: {
        tableColumns() {
            const columns = [
                {
                    prop: "unitId",
                    label: "Unit Id",
                },
                {
                    prop: "description",
                    label: "Description",
                    minWidth: 150,
                },
                {
                    prop: "manufacturer.name",
                    label: "Manufacturer",
                    minWidth: 150,
                },
                {
                    prop: "relatedNumber",
                    label: "S/N",
                },
                {
                    prop: "itemNumber",
                    label: "Item No.",
                },
                {
                    prop: "quantity",
                    label: "Qty",
                },
                {
                    prop: "expectedAt",
                    label: "Expected By",
                    formatter: (_row, _column, value) => this.formatDate(value),
                },
            ];
            return columns;
        },
    },
    methods: {
        formatDate(date) {
            if (date) {
                return moment(date).format("MM/DD/YYYY");
            }
            return "--";
        },
    },
};
</script>

<style module>
.row {
    cursor: pointer;
    background-color: white !important;
}
</style>
